import { 
    CreatePaymentDto, 
    DeletePaymentDto,
    EditPaymentDto,
    GetPaymentDto, 
    MessageResponseDto, 
    PaymentApiFp,
    PaymentControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponsePaymentModel = PaymentControllerGet200Response;
export type GetPaymentModel = GetPaymentDto;
export type MutateResponsePaymentModel = MessageResponseDto;
export type CreatePaymentModel = CreatePaymentDto;
export type UpdatePaymentModel = EditPaymentDto;
export type DeletePaymentModel = DeletePaymentDto;

export const apiPaymentFp = PaymentApiFp(apiConfig);
export const getPaymentController = apiPaymentFp.paymentControllerGet;
export const createPaymentController = apiPaymentFp.paymentControllerCreate;
export const updatePaymentController = apiPaymentFp.paymentControllerEdit;
export const deletePaymentController = apiPaymentFp.paymentControllerDelete;

export const QueryKeyPayment = QueryKey.Payment;